import { getFunctions } from 'firebase/functions'
import { getFirebaseApp } from './app'

const FUNCTIONS_REGION = 'southamerica-east1'

let functions: ReturnType<typeof getFunctions> | null = null

export function getFirebaseFunctions() {
  if (!functions) {
    functions = getFunctions(getFirebaseApp(), FUNCTIONS_REGION)
  }
  return functions
}
